import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage, { getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @function CaptureMabiEDEStatementsViewStatementsDropdown
 * @param {OBJECT} props - None used for now.
 * @description - Component for capture "005_view_statements_dropdown" in mabi23 capture group "Statements".
 */
export default function CaptureMabiEDEStatementsViewStatementsDropdown(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "mobileMenu" ], { isActive: true })
    .submit();

    useEffect(() => {
        document.querySelector(".mobile [data-point=edeStatementsMainNav_View_Statements] a").click()
    }, []);

    return <EDEStatementsPage ui={ ui } />
}